<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99996 0.666016C2.79163 0.666016 0.166626 3.29102 0.166626 6.49935C0.166626 9.70768 2.79163 12.3327 5.99996 12.3327C9.20829 12.3327 11.8333 9.70768 11.8333 6.49935C11.8333 3.29102 9.20829 0.666016 5.99996 0.666016ZM5.99996 9.41602C5.64996 9.41602 5.41663 9.18268 5.41663 8.83268C5.41663 8.48268 5.64996 8.24935 5.99996 8.24935C6.34996 8.24935 6.58329 8.48268 6.58329 8.83268C6.58329 9.18268 6.34996 9.41602 5.99996 9.41602ZM6.58329 6.49935C6.58329 6.84935 6.34996 7.08268 5.99996 7.08268C5.64996 7.08268 5.41663 6.84935 5.41663 6.49935V4.16602C5.41663 3.81602 5.64996 3.58268 5.99996 3.58268C6.34996 3.58268 6.58329 3.81602 6.58329 4.16602V6.49935Z"
      fill="#FF6C69"
    />
  </svg>
</template>
